// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "booking_account".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { bookingProviderValues } from '@borradh-workspace/labels';
/** Response atom for the "booking_account" table (1:1 with a DB row, on the wire). */
export const bookingAccountAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    userId: z.string(),
    provider: z.enum(bookingProviderValues),
    externalAccountId: z.string().nullable(),
    email: z.string().nullable(),
    displayName: z.string().nullable(),
    config: z.unknown().nullable(),
    isActive: z.boolean(),
    encryptedCredentials: z.string(),
    lastSyncAt: z.string().datetime().nullable(),
    tokenExpiresAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=bookingAccount.js.map